import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { Star, Bookmark, Sparkles, MapPin, MessageCircle, Tag } from "lucide-react";

const PERKS = [
  { icon: Star, label: "Rate every photo 1–10" },
  { icon: Bookmark, label: "Build your own galleries" },
  { icon: Sparkles, label: "AI search + smart galleries" },
  { icon: MapPin, label: "Explore the interactive map" },
  { icon: MessageCircle, label: "Message creators directly" },
  { icon: Tag, label: "Add your own private tags" },
];

export const JoinGate = () => {
  const { joinOpen, closeJoin, openAuth } = useAuth();
  const join = () => { closeJoin(); openAuth("register"); };
  const _authRoute = typeof window !== "undefined" && ["/login", "/verify-email", "/reset-password"].includes(window.location.pathname);
  return (
    <Dialog open={joinOpen && !_authRoute} onOpenChange={(o) => !o && closeJoin()}>
      <DialogContent data-testid="join-gate" className="max-w-md bg-card border-border overflow-hidden p-0">
        <div className="p-7">
          <span className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.2em] uppercase font-bold text-primary bg-primary/10 border border-primary/25 rounded-full px-3 py-1">
            100% Free to join
          </span>
          <h2 className="font-heading text-3xl mt-4 leading-tight">Members only —<br />join free to rate & save</h2>
          <p className="text-sm text-muted-foreground mt-2">You can browse and see what's trending for free. Create a free account to rate, save galleries and unlock everything below.</p>

          <div className="grid grid-cols-2 gap-2.5 mt-5">
            {PERKS.map((p) => (
              <div key={p.label} className="flex items-center gap-2 text-sm text-foreground/90">
                <span className="w-7 h-7 rounded-full bg-primary/12 text-primary flex items-center justify-center shrink-0"><p.icon className="w-3.5 h-3.5" /></span>
                <span className="leading-tight">{p.label}</span>
              </div>
            ))}
          </div>

          <button data-testid="join-gate-cta" onClick={join}
            className="mt-6 w-full rounded-full bg-primary text-primary-foreground py-3 font-medium hover:-translate-y-0.5 transition-transform">
            Join Free — takes seconds
          </button>
          <p className="text-[11px] text-muted-foreground text-center mt-3">No payment required · 18+ only · free forever</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
